import CapTable from './container';

export default CapTable;
